module.exports = __webpack_public_path__ + "img/logo.b29324c4.svg";